import { axiosPostData } from "../../../helpers/fetch_services";
import { normalizeId } from "../survey/surveyPreviewUtils";
import { getClientConnectVisibleQuestions } from "./clientConnectSurveyQuestions";

function filterAnswersToVisibleQuestions(answers, visibleQuestions) {
  const visibleIds = new Set(
    (visibleQuestions || [])
      .map((question) => normalizeId(question?._id))
      .filter(Boolean),
  );

  return Object.fromEntries(
    Object.entries(answers || {}).filter(([answerId]) =>
      visibleIds.has(normalizeId(answerId)),
    ),
  );
}

export function buildClientConnectFormData(survey) {
  const { answeres: answers, contactDetails, directorMessage } = survey;
  const surveyConfig = survey.survey_without_login;
  const questions = surveyConfig?.questions || [];
  const visibleQuestions = getClientConnectVisibleQuestions(
    surveyConfig,
    answers,
  );
  const visibleAnswers = filterAnswersToVisibleQuestions(
    answers,
    visibleQuestions,
  );
  const answersClone = JSON.parse(JSON.stringify(visibleAnswers));

  const filesArray = [];

  Object.keys(visibleAnswers).forEach((item) => {
    const question = questions.find(
      (q) => normalizeId(q._id) === normalizeId(item),
    );
    if (question && "isFile" in visibleAnswers[item]) {
      answersClone[item] = {
        ...answersClone[item],
        questionType:
          question.questionType === "handwrittenInput"
            ? "base64"
            : question.questionType,
      };
      filesArray.push({ [item]: visibleAnswers[item] });
    }
  });

  const metaData = {
    survey_id: localStorage.getItem("survey") || "",
    response_user_id: localStorage.getItem("user_id") || "",
    tag_id: localStorage.getItem("tag_id")
      ? localStorage.getItem("tag_id")
      : localStorage.getItem("tag"),
  };

  const audit = localStorage.getItem("audit") ?? null;
  const email = localStorage.getItem("email") ?? null;
  if (audit) {
    metaData.audit = audit;
    metaData.email = email;
  }

  [
    "override_id",
    "task_id",
    "is_override",
    "override_date",
    "response_user_id",
  ].forEach((key) => {
    const value = localStorage.getItem(key);
    if (value) {
      metaData[key] = value;
    }
  });

  const responseData = {
    customer_name: contactDetails?.name,
    customer_email: contactDetails?.email,
    customer_phone: contactDetails?.phone,
  };

  const ticketCreatorId = localStorage.getItem("creator_id") ?? null;
  const formData = new FormData();
  formData.append("metaData", JSON.stringify(metaData));
  formData.append("jsonData", JSON.stringify(answersClone));
  formData.append("responseData", JSON.stringify(responseData));
  formData.append("director_message", directorMessage || "");
  formData.append("ticketCreatorId", ticketCreatorId);

  if (filesArray.length) {
    filesArray.forEach((item) => {
      const key = Object.keys(item)[0];
      const { questionType } = answersClone[key] || {};
      let images = [];

      if (questionType === "file") {
        if (item[key]?.value?.length) {
          item[key].value.forEach((img) => images.push(img));
        }
        if (item[key]?.image?.length) {
          item[key].image.forEach((img) => images.push(img));
        }
      } else {
        images = item[key]?.image || [];
      }

      if (images.length) {
        images.forEach((image) => {
          formData.append(key, image);
        });
      }
    });
  }

  return formData;
}

export async function submitClientConnectAnswers(survey) {
  const formData = buildClientConnectFormData(survey);
  const result = await axiosPostData("survey/answerSurvey", formData, {
    preserveSessionOn401: true,
  });
  return Boolean(result && result.status >= 200 && result.status < 300);
}
